var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1413(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 268,
    viewBox: "0 0 268 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 63",
    filter: "url(#filter0_d_37_4579)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 132,
    r: 99,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M111.812 212.489C108.841 214.535 105.803 216.647 103.746 219.61C101.688 222.574 100.79 226.619 102.443 229.826L102.401 230.025C103.654 230.466 104.999 230.576 106.307 230.346C107.615 230.115 108.841 229.552 109.868 228.71C112.483 226.515 113.304 222.898 113.971 219.549L115.944 209.645L111.812 212.489Z",
    fill: "#FF9A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M114.674 222.479C112.692 222.917 110.661 223.376 108.961 224.486C107.262 225.596 105.938 227.516 106.122 229.537L106.058 229.633C106.618 230.127 107.296 230.469 108.027 230.626C108.757 230.782 109.516 230.748 110.23 230.526C112.058 229.934 113.25 228.222 114.306 226.617L117.43 221.869L114.674 222.479Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M189.31 80.4795H74.2872C74.2223 80.4793 74.16 80.4533 74.1141 80.4073C74.0682 80.3612 74.0425 80.2989 74.0425 80.2339C74.0425 80.1689 74.0682 80.1066 74.1141 80.0605C74.16 80.0145 74.2223 79.9885 74.2872 79.9883H189.31C189.375 79.9885 189.437 80.0145 189.483 80.0605C189.529 80.1066 189.555 80.1689 189.555 80.2339C189.555 80.2989 189.529 80.3612 189.483 80.4073C189.437 80.4533 189.375 80.4793 189.31 80.4795Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M79.3027 76.7473C80.7948 76.7473 82.0044 75.5377 82.0044 74.0455C82.0044 72.5534 80.7948 71.3438 79.3027 71.3438C77.8105 71.3438 76.6009 72.5534 76.6009 74.0455C76.6009 75.5377 77.8105 76.7473 79.3027 76.7473Z",
    fill: "url(#paint0_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M88.6354 76.7473C90.1276 76.7473 91.3372 75.5377 91.3372 74.0455C91.3372 72.5534 90.1276 71.3438 88.6354 71.3438C87.1433 71.3438 85.9337 72.5534 85.9337 74.0455C85.9337 75.5377 87.1433 76.7473 88.6354 76.7473Z",
    fill: "url(#paint1_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M97.9684 76.7473C99.4606 76.7473 100.67 75.5377 100.67 74.0455C100.67 72.5534 99.4606 71.3438 97.9684 71.3438C96.4763 71.3438 95.2667 72.5534 95.2667 74.0455C95.2667 75.5377 96.4763 76.7473 97.9684 76.7473Z",
    fill: "url(#paint2_linear_37_4579)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M189.079 84.5645H76.8323V151.863H189.079V84.5645Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M134.906 120.768C139.532 120.768 143.282 117.018 143.282 112.392C143.282 107.766 139.532 104.016 134.906 104.016C130.28 104.016 126.53 107.766 126.53 112.392C126.53 117.018 130.28 120.768 134.906 120.768Z",
    fill: "#9E616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M149.019 151.865H128.016L129.195 125.306L129.34 125.154L131.425 122.953H138.057L140.518 125.336L140.712 125.525L145.949 130.543L149.019 151.865Z",
    fill: "#FF9A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M133.83 151.864H117.867C117.762 141.7 117.678 134.032 117.678 134.032L118.494 133.536L118.499 133.533L127.451 128.098L129.33 125.045L129.34 125.153L129.893 131.588C129.893 131.588 132.897 141.292 133.83 151.864Z",
    fill: "url(#paint3_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M155.55 151.864H141.346C140.587 148.42 140.191 145.141 140.363 142.408C141.061 131.239 139.452 125.045 140.15 125.045L140.518 125.335L144.9 128.795L150.67 130.91L154.673 132.379L155.371 132.634V132.971C155.373 134.661 155.39 142.508 155.55 151.864Z",
    fill: "url(#paint4_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M126.981 115.013C126.981 115.013 127.693 113.763 127.527 109.588C127.362 105.413 133.72 107.774 139.032 107.376C144.345 106.978 143.22 114.346 143.22 114.346C143.22 114.346 143.604 113.908 144.424 110.352C145.245 106.796 143.382 103.251 143.382 103.251C142.833 99.5143 139.876 100.712 139.876 100.712C141.3 101.266 141.026 102.452 141.026 102.452C139.821 100.338 136.864 101.536 136.864 101.536C132.919 99.0611 128.922 102.32 128.922 102.32C124.157 103.402 126.952 107.191 126.952 107.191C122.16 109.612 126.981 115.013 126.981 115.013Z",
    fill: "url(#paint5_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M113.243 151.862C113.65 143.71 113.962 137.314 113.839 136.82C113.496 135.447 118.347 133.588 118.494 133.534L118.496 133.531H118.499L119.425 134.03L120.103 151.862H113.243Z",
    fill: "url(#paint6_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M158.89 151.865H151.681L149.618 131.487L150.468 130.865C150.468 130.865 150.541 130.882 150.669 130.912C151.33 131.076 153.462 131.634 154.673 132.381C154.941 132.532 155.177 132.733 155.37 132.973C155.488 133.114 155.547 133.295 155.535 133.479C155.473 134.056 157.045 142.215 158.89 151.865Z",
    fill: "url(#paint7_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M184.033 157.488H90.9217C90.5636 157.489 90.2204 157.628 89.9674 157.875C89.7144 158.122 89.5723 158.458 89.5723 158.807C89.5723 159.156 89.7144 159.491 89.9674 159.738C90.2204 159.986 90.5636 160.125 90.9217 160.125H184.033C184.21 160.126 184.386 160.092 184.551 160.026C184.715 159.959 184.864 159.862 184.99 159.74C185.116 159.617 185.215 159.472 185.283 159.312C185.351 159.152 185.386 158.98 185.386 158.807C185.386 158.633 185.351 158.462 185.283 158.302C185.215 158.142 185.116 157.996 184.99 157.874C184.864 157.751 184.715 157.654 184.551 157.588C184.386 157.522 184.21 157.488 184.033 157.488Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M158.723 157.488V160.125H90.9201C90.5624 160.125 90.2196 159.986 89.9669 159.738C89.7142 159.491 89.5723 159.156 89.5723 158.807C89.5723 158.458 89.7142 158.122 89.9669 157.875C90.2196 157.628 90.5624 157.489 90.9201 157.488H158.723Z",
    fill: "url(#paint8_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M158.722 161.591C160.178 161.591 161.359 160.344 161.359 158.807C161.359 157.27 160.178 156.023 158.722 156.023C157.265 156.023 156.084 157.27 156.084 158.807C156.084 160.344 157.265 161.591 158.722 161.591Z",
    fill: "url(#paint9_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M137.332 181.22C136.231 181.22 135.154 180.894 134.239 180.282C133.323 179.67 132.61 178.801 132.188 177.784C131.767 176.766 131.657 175.647 131.872 174.567C132.086 173.487 132.617 172.495 133.395 171.717C134.174 170.938 135.166 170.408 136.246 170.193C137.326 169.978 138.445 170.088 139.462 170.51C140.48 170.931 141.349 171.645 141.961 172.56C142.573 173.476 142.899 174.552 142.899 175.653C142.897 177.129 142.31 178.544 141.267 179.588C140.223 180.632 138.808 181.219 137.332 181.22ZM137.332 170.514C136.315 170.514 135.322 170.816 134.477 171.38C133.632 171.945 132.973 172.748 132.584 173.687C132.195 174.626 132.093 175.659 132.292 176.656C132.49 177.653 132.979 178.568 133.698 179.287C134.417 180.006 135.332 180.495 136.329 180.693C137.326 180.892 138.359 180.79 139.298 180.401C140.237 180.012 141.04 179.353 141.605 178.508C142.169 177.663 142.471 176.67 142.471 175.653C142.469 174.291 141.927 172.984 140.964 172.021C140 171.058 138.694 170.516 137.332 170.514Z",
    fill: "#FF9A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M136.747 178.585C136.669 178.585 136.595 178.563 136.54 178.524C136.485 178.484 136.454 178.431 136.454 178.376V172.936C136.453 172.908 136.461 172.881 136.475 172.855C136.49 172.83 136.511 172.806 136.539 172.787C136.566 172.767 136.598 172.751 136.634 172.741C136.67 172.73 136.708 172.725 136.747 172.725C136.785 172.725 136.824 172.73 136.86 172.741C136.895 172.751 136.928 172.767 136.955 172.787C136.982 172.806 137.004 172.83 137.018 172.855C137.033 172.881 137.04 172.908 137.04 172.936V178.376C137.04 178.431 137.009 178.484 136.954 178.524C136.899 178.563 136.824 178.585 136.747 178.585Z",
    fill: "#FF9A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M138.211 178.585C138.134 178.585 138.059 178.563 138.004 178.524C137.949 178.484 137.918 178.431 137.918 178.376V172.936C137.918 172.908 137.925 172.881 137.94 172.855C137.954 172.83 137.976 172.806 138.003 172.787C138.03 172.767 138.063 172.751 138.099 172.741C138.134 172.73 138.173 172.725 138.211 172.725C138.25 172.725 138.288 172.73 138.324 172.741C138.36 172.751 138.392 172.767 138.419 172.787C138.447 172.806 138.468 172.83 138.483 172.855C138.497 172.881 138.505 172.908 138.504 172.936V178.376C138.504 178.431 138.473 178.484 138.418 178.524C138.364 178.563 138.289 178.585 138.211 178.585Z",
    fill: "#FF9A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M111.84 175.653C111.84 174.552 112.166 173.476 112.778 172.56C113.39 171.645 114.259 170.931 115.277 170.51C116.294 170.088 117.413 169.978 118.493 170.193C119.573 170.408 120.565 170.938 121.344 171.717C122.122 172.495 122.652 173.487 122.867 174.567C123.082 175.647 122.972 176.766 122.55 177.784C122.129 178.801 121.416 179.67 120.5 180.282C119.584 180.894 118.508 181.22 117.407 181.22C115.931 181.219 114.516 180.632 113.472 179.588C112.429 178.544 111.842 177.129 111.84 175.653ZM112.268 175.653C112.268 176.67 112.569 177.663 113.134 178.508C113.699 179.353 114.501 180.012 115.44 180.401C116.379 180.79 117.413 180.892 118.41 180.693C119.406 180.495 120.322 180.006 121.041 179.287C121.76 178.568 122.249 177.653 122.447 176.656C122.646 175.659 122.544 174.626 122.155 173.687C121.766 172.748 121.107 171.945 120.262 171.38C119.417 170.816 118.423 170.514 117.407 170.514C116.045 170.516 114.738 171.058 113.775 172.021C112.812 172.984 112.27 174.291 112.268 175.653Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M119.87 177.415C119.909 177.415 119.946 177.402 119.977 177.38C120.007 177.358 120.029 177.326 120.039 177.291C120.049 177.255 120.046 177.218 120.032 177.184C120.017 177.15 119.991 177.121 119.958 177.103L117.344 175.657L119.958 174.21C119.998 174.188 120.027 174.152 120.039 174.109C120.051 174.066 120.045 174.02 120.022 173.982C119.998 173.944 119.96 173.916 119.916 173.904C119.871 173.893 119.824 173.899 119.784 173.921L116.909 175.512C116.882 175.527 116.86 175.548 116.845 175.573C116.83 175.598 116.822 175.627 116.822 175.657C116.822 175.686 116.83 175.715 116.845 175.74C116.86 175.765 116.882 175.787 116.909 175.801L119.784 177.392C119.81 177.407 119.84 177.415 119.87 177.415Z",
    fill: "url(#paint10_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M116.089 178.294C116.128 178.294 116.166 178.274 116.193 178.239C116.22 178.203 116.236 178.155 116.236 178.105V173.208C116.236 173.158 116.22 173.11 116.193 173.075C116.166 173.039 116.128 173.02 116.089 173.02C116.051 173.02 116.013 173.039 115.986 173.075C115.958 173.11 115.943 173.158 115.943 173.208V178.105C115.943 178.155 115.958 178.203 115.986 178.239C116.013 178.274 116.051 178.294 116.089 178.294Z",
    fill: "url(#paint11_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M157.257 181.22C156.156 181.22 155.079 180.894 154.164 180.282C153.248 179.67 152.535 178.801 152.113 177.784C151.692 176.766 151.582 175.647 151.796 174.567C152.011 173.487 152.541 172.495 153.32 171.717C154.099 170.938 155.091 170.408 156.171 170.193C157.25 169.978 158.37 170.088 159.387 170.51C160.404 170.931 161.274 171.645 161.886 172.56C162.497 173.476 162.824 174.552 162.824 175.653C162.822 177.129 162.235 178.544 161.191 179.588C160.148 180.632 158.733 181.219 157.257 181.22ZM157.257 170.514C156.24 170.514 155.247 170.816 154.402 171.38C153.557 171.945 152.898 172.748 152.509 173.687C152.12 174.626 152.018 175.659 152.216 176.656C152.415 177.653 152.904 178.568 153.623 179.287C154.342 180.006 155.257 180.495 156.254 180.693C157.251 180.892 158.284 180.79 159.223 180.401C160.162 180.012 160.965 179.353 161.529 178.508C162.094 177.663 162.396 176.67 162.396 175.653C162.394 174.291 161.852 172.984 160.889 172.021C159.925 171.058 158.619 170.516 157.257 170.514Z",
    fill: "url(#paint12_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M155.088 177.415C155.05 177.415 155.012 177.402 154.982 177.38C154.951 177.358 154.929 177.326 154.92 177.291C154.91 177.255 154.912 177.218 154.927 177.184C154.942 177.15 154.967 177.121 155.001 177.103L157.614 175.656L155.001 174.21C154.961 174.188 154.932 174.151 154.92 174.108C154.908 174.066 154.914 174.02 154.937 173.982C154.96 173.944 154.998 173.916 155.043 173.904C155.087 173.893 155.135 173.899 155.175 173.921L158.05 175.512C158.076 175.526 158.098 175.547 158.113 175.573C158.129 175.598 158.137 175.627 158.137 175.656C158.137 175.686 158.129 175.714 158.113 175.74C158.098 175.765 158.076 175.786 158.05 175.801L155.175 177.392C155.148 177.407 155.118 177.415 155.088 177.415Z",
    fill: "url(#paint13_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M158.869 178.294C158.83 178.294 158.793 178.274 158.765 178.239C158.738 178.203 158.722 178.155 158.722 178.105V173.208C158.722 173.158 158.738 173.11 158.765 173.075C158.793 173.039 158.83 173.02 158.869 173.02C158.908 173.02 158.945 173.039 158.972 173.075C159 173.11 159.015 173.158 159.015 173.208V178.105C159.015 178.155 159 178.203 158.972 178.239C158.945 178.274 158.908 178.294 158.869 178.294Z",
    fill: "url(#paint14_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M89.0576 178.494C88.8164 178.252 88.6312 177.96 88.5149 177.639C88.3985 177.318 88.354 176.976 88.3844 176.636C88.4148 176.296 88.5194 175.966 88.6909 175.671C88.8623 175.376 89.0964 175.122 89.3766 174.927L87.1315 166.938L91.2397 168.249L92.7419 175.635C93.0382 176.127 93.1437 176.712 93.0382 177.277C92.9327 177.842 92.6236 178.348 92.1695 178.701C91.7153 179.053 91.1477 179.227 90.5742 179.188C90.0007 179.15 89.4611 178.903 89.0576 178.494Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M87.9593 138.69L87.1083 137.805C87.1083 137.805 84.4772 139.612 85.0339 145.214C85.4451 149.352 84.1457 151.107 84.2909 163.134L87.9593 174.148L92.2021 171.924L89.1325 158.334L87.9593 138.69Z",
    fill: "#FF961F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M91.1424 228.084H94.1847L95.6322 216.35L91.1418 216.35L91.1424 228.084Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M90.3669 227.09L96.3584 227.09C97.371 227.09 98.3424 227.492 99.0584 228.208C99.7744 228.924 100.177 229.895 100.177 230.908V231.032L90.3671 231.032L90.3669 227.09Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M100.014 227.007L103.034 227.377L105.899 215.906L101.442 215.359L100.014 227.007Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M99.3648 225.928L105.312 226.657C106.317 226.78 107.232 227.298 107.855 228.096C108.479 228.894 108.76 229.906 108.637 230.912L108.622 231.035L98.885 229.841L99.3648 225.928Z",
    fill: "url(#paint15_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M89.5649 167.92C89.5649 167.92 83.7044 171.925 86.6345 182.767L90.5971 224.848L95.3049 224.815L97.2989 204.05L98.6541 189.432L103.182 204.548L99.4578 223.097L104.955 223.676L111.54 202.105L108.364 171.394L89.5649 167.92Z",
    fill: "url(#paint16_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M103.706 136.669L100.726 134.273L92.8233 133.947L87.108 137.806C87.108 137.806 86.518 151.547 90.3855 163.787L88.3579 168.9L108.631 171.444L103.706 136.669Z",
    fill: "#FFA034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M97.3157 131.004C101.059 131.004 104.094 127.969 104.094 124.226C104.094 120.482 101.059 117.447 97.3157 117.447C93.572 117.447 90.5372 120.482 90.5372 124.226C90.5372 127.969 93.572 131.004 97.3157 131.004Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M99.0955 115.846H97.5891C96.5395 115.533 95.4313 115.47 94.3528 115.661C93.2744 115.852 92.2555 116.292 91.3773 116.947C90.4991 117.601 89.7859 118.452 89.2946 119.431C88.8032 120.41 88.5473 121.49 88.5472 122.585L86.2011 130.327C86.1335 130.55 86.119 130.786 86.159 131.016C86.1989 131.246 86.2921 131.463 86.4311 131.65C86.5701 131.838 86.751 131.99 86.9594 132.095C87.1678 132.2 87.3978 132.254 87.6311 132.254H88.7762C89.2558 131.571 89.4649 130.735 89.3633 129.906C89.5762 130.425 89.7254 130.967 89.8076 131.522C89.8342 131.766 89.8291 132.012 89.7926 132.254H99.7551C99.8195 131.277 99.4958 130.314 98.8543 129.574C99.657 130.376 100.355 131.277 100.93 132.254H101.118C101.514 132.254 101.894 132.097 102.174 131.817C102.454 131.536 102.612 131.156 102.612 130.76V123.171H106.421C106.421 122.209 106.231 121.256 105.863 120.368C105.495 119.479 104.955 118.671 104.275 117.991C103.595 117.311 102.788 116.771 101.899 116.403C101.01 116.035 100.057 115.846 99.0955 115.846Z",
    fill: "url(#paint17_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M106.638 177.91C106.397 177.668 106.211 177.376 106.095 177.055C105.979 176.734 105.934 176.392 105.965 176.052C105.995 175.712 106.1 175.383 106.271 175.087C106.442 174.792 106.677 174.538 106.957 174.343L104.712 166.354L108.82 167.665L110.322 175.051C110.618 175.543 110.724 176.128 110.618 176.693C110.513 177.258 110.204 177.764 109.75 178.117C109.296 178.469 108.728 178.643 108.154 178.604C107.581 178.566 107.041 178.319 106.638 177.91Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M101.137 138.182L103.707 136.666C103.707 136.666 107.749 135.953 108.18 141.338C108.612 146.723 109.233 160.702 109.233 160.702L110.494 172.485L105.816 173.483L100.439 157.369L101.137 138.182Z",
    fill: "#FF961F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M168.726 154.579L177.047 149.459C177.047 149.459 180.816 144.99 183.154 143.971L185.98 146.674L181.319 152.294L170.161 157.2C170.004 157.459 169.781 157.672 169.515 157.818C169.249 157.964 168.95 158.038 168.646 158.031C168.343 158.024 168.047 157.938 167.788 157.781C167.529 157.623 167.316 157.4 167.17 157.134C167.024 156.868 166.951 156.568 166.958 156.265C166.965 155.962 167.052 155.666 167.21 155.407C167.367 155.148 167.591 154.935 167.857 154.79C168.123 154.644 168.423 154.572 168.726 154.579Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M175.652 211.876L173.186 211.876L172.013 202.365L175.653 202.365L175.652 211.876Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M176.281 211.071L175.587 211.071L172.877 209.969L171.425 211.071H171.425C170.604 211.071 169.817 211.397 169.237 211.977C168.656 212.557 168.33 213.344 168.33 214.165V214.266L176.281 214.266L176.281 211.071Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M193.212 209.555L190.876 210.346L186.714 201.714L190.161 200.547L193.212 209.555Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M193.549 208.592L192.892 208.814L189.972 208.64L188.95 210.149L188.949 210.149C188.172 210.412 187.531 210.974 187.168 211.71C186.804 212.445 186.748 213.295 187.011 214.073L187.043 214.168L194.574 211.618L193.549 208.592Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M190.354 170.91C190.354 170.91 190.641 174.365 189.922 177.676C189.202 180.987 187.653 191.979 187.653 191.979C190.79 197.136 192.609 202.211 192.952 207.347L188.536 207.701L182.213 192.697L181.572 177.676L176.965 187.898L177.202 188.687C177.258 188.874 177.251 189.074 177.182 189.256C177.114 189.439 176.987 189.594 176.822 189.697C176.822 189.697 177.253 192.504 176.965 192.504C176.677 192.504 175.957 192.936 175.957 192.936C177.752 198.523 177.993 203.874 176.347 208.937L172.461 208.761L169.911 186.746L171.782 174.797L171.926 172.494L172.574 172.52L172.904 171.558L173.51 169.902L190.354 170.91Z",
    fill: "url(#paint18_linear_37_4579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M190.602 171.635L190.628 171.599C191.998 169.68 189.937 165.07 189.626 164.402L190.936 163.977L192.08 154.29L192.918 150.943C193.233 149.678 193.206 148.352 192.84 147.1C192.473 145.849 191.78 144.718 190.832 143.823L188.897 141.998L186.545 138.518H182.752L181.451 140.974C180.191 141.265 179.072 141.99 178.29 143.021C177.509 144.053 177.114 145.326 177.174 146.618L177.469 153.061L176.315 161.083L176.314 162.535L174.311 165.819L173.875 167.855C173.694 168.094 172.502 169.683 172.502 170.117C172.502 170.183 172.55 170.246 172.653 170.316C173.466 170.866 177.956 171.987 179.943 171.192C182.059 170.346 190.474 171.615 190.558 171.628L190.602 171.635Z",
    fill: "#FF9A27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M184.158 137.394C181.384 137.394 179.135 135.145 179.135 132.371C179.135 129.597 181.384 127.348 184.158 127.348C186.933 127.348 189.182 129.597 189.182 132.371C189.182 135.145 186.933 137.394 184.158 137.394Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M170.518 162.782L175.794 154.56C175.794 154.56 177.251 148.898 178.917 146.965L182.636 148.175L180.873 155.261L172.948 164.521C172.919 164.823 172.81 165.112 172.634 165.359C172.458 165.606 172.22 165.802 171.944 165.927C171.668 166.053 171.363 166.103 171.061 166.074C170.76 166.044 170.471 165.936 170.224 165.759C169.977 165.583 169.782 165.345 169.656 165.068C169.531 164.792 169.481 164.488 169.511 164.186C169.541 163.884 169.649 163.595 169.826 163.349C170.003 163.102 170.242 162.907 170.518 162.782Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M180.715 126.572C181.075 126.561 180.951 125.882 181.241 125.666C181.243 125.672 181.244 125.679 181.246 125.685C181.284 125.832 181.368 125.962 181.485 126.058C181.603 126.153 181.748 126.208 181.9 126.214C182.051 126.221 182.2 126.178 182.326 126.094C182.451 126.009 182.546 125.886 182.597 125.743C182.645 125.578 182.732 125.427 182.851 125.302C182.969 125.178 183.116 125.083 183.279 125.027C183.297 125.656 183.773 126.202 184.34 126.474C184.908 126.746 185.555 126.791 186.184 126.8C186.813 126.809 187.452 126.788 188.062 126.942C188.672 127.096 189.265 127.458 189.526 128.031C189.787 128.604 189.601 129.392 189.031 129.659C189.472 129.661 189.847 130.025 190 130.44C190.125 130.865 190.157 131.312 190.095 131.75C189.971 133.375 189.669 135.124 188.486 136.244C187.584 137.097 186.294 137.441 185.053 137.436C183.811 137.431 184.029 137.317 182.829 137C182.829 137 181.688 133.729 181.975 133.407C182.262 133.085 182.501 132.673 182.449 132.245C182.397 131.816 181.937 131.433 181.537 131.596C181.604 131.424 181.655 131.391 181.687 131.4C181.667 131.351 181.649 131.301 181.634 131.251C181.559 130.993 181.423 130.756 181.239 130.56C181.054 130.365 180.826 130.216 180.573 130.126C180.317 130.043 180.042 130.04 179.785 130.118C179.527 130.196 179.3 130.351 179.133 130.561C177.819 129.329 178.634 126.633 180.715 126.572Z",
    fill: "url(#paint19_linear_37_4579)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_4579",
    x: 0,
    y: 0,
    width: 268,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911654 0 0 0 0 0.754167 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_4579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_4579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_4579",
    x1: 76.6009,
    y1: 74.3801,
    x2: 82.0044,
    y2: 74.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_4579",
    x1: 85.9337,
    y1: 74.3801,
    x2: 91.3372,
    y2: 74.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_4579",
    x1: 95.2667,
    y1: 74.3801,
    x2: 100.67,
    y2: 74.3801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_4579",
    x1: 117.678,
    y1: 140.115,
    x2: 133.83,
    y2: 140.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_4579",
    x1: 139.97,
    y1: 140.115,
    x2: 155.55,
    y2: 140.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_37_4579",
    x1: 124.83,
    y1: 108.668,
    x2: 144.633,
    y2: 108.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_37_4579",
    x1: 113.243,
    y1: 143.832,
    x2: 120.103,
    y2: 143.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_37_4579",
    x1: 149.618,
    y1: 142.666,
    x2: 158.89,
    y2: 142.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_37_4579",
    x1: 89.5723,
    y1: 158.97,
    x2: 158.723,
    y2: 158.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_37_4579",
    x1: 156.084,
    y1: 159.152,
    x2: 161.359,
    y2: 159.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_37_4579",
    x1: 116.822,
    y1: 175.874,
    x2: 120.045,
    y2: 175.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_37_4579",
    x1: 115.943,
    y1: 175.983,
    x2: 116.236,
    y2: 175.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_37_4579",
    x1: 151.689,
    y1: 176.343,
    x2: 162.824,
    y2: 176.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_37_4579",
    x1: 154.914,
    y1: 175.874,
    x2: 158.137,
    y2: 175.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_37_4579",
    x1: 158.722,
    y1: 175.983,
    x2: 159.015,
    y2: 175.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_37_4579",
    x1: 98.885,
    y1: 228.797,
    x2: 108.665,
    y2: 228.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_37_4579",
    x1: 85.8141,
    y1: 199.909,
    x2: 111.54,
    y2: 199.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_37_4579",
    x1: 86.1369,
    y1: 124.938,
    x2: 106.421,
    y2: 124.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_37_4579",
    x1: 192.952,
    y1: 191.837,
    x2: 169.911,
    y2: 191.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_37_4579",
    x1: 190.126,
    y1: 132,
    x2: 178.497,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1413);
export default __webpack_public_path__ + "static/media/Group1413.33d24f2f6fb8a365a1b8a47e5e7db042.svg";
export { ForwardRef as ReactComponent };